module.exports = __webpack_public_path__ + "img/norrtag-felrapport.061bfb57.png";